import { render, staticRenderFns } from "./Winner.vue?vue&type=template&id=864222d4&scoped=true"
import script from "./Winner.vue?vue&type=script&lang=ts"
export * from "./Winner.vue?vue&type=script&lang=ts"
import style0 from "./Winner.vue?vue&type=style&index=0&id=864222d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864222d4",
  null
  
)

export default component.exports